import { dom, library, config } from "@fortawesome/fontawesome-svg-core";
import * as faRegular from "@fortawesome/pro-regular-svg-icons";
import * as faSolid from "@fortawesome/pro-solid-svg-icons";

// Whenever you want to use a new icon in a view_component please add it here otherwise it's not included
library.add(
  faRegular.faCheck,
  faRegular.faBrowser,
  faRegular.faKey,
  faSolid.faTriangleExclamation,
  faSolid.faPhoneFlip
);

config.autoReplaceSvg = true;
config.observeMutations = true;

// adds support for turbo and dynamic icon replacement
dom.watch();
